import { FC, useMemo, useState } from "react"

import Form from "../../../form"
import { useFindPricingSetsQuery } from "../../../../../redux/queries"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { Integration } from "../../../../../types"

interface Props {
  integration?: Integration
}

const PricingSetSelector: FC<Props> = ({ integration }) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  // Get all the workflows from a brand
  const { data: pricingSets = [], isLoading } = useFindPricingSetsQuery({
    brand_id: integration?.brand_id as string
  })

  const [selectedPricingSetID, setSelectedPricingSetID] = useState<
    number | string
  >(app_settings?.pricing_set_id ?? "")

  const selectedPricingSet = useMemo(() => {
    const pricingSet = pricingSets.find(
      pricingSet => String(pricingSet.id) === String(selectedPricingSetID)
    )
    return pricingSet ?? undefined
  }, [selectedPricingSetID, pricingSets])

  const handlePricingSetSelect = (pricingSetID: string) => {
    if (String(pricingSetID) !== String(selectedPricingSetID)) {
      setSelectedPricingSetID(pricingSetID) // set the state
      saveAppSetting({ pricing_set_id: pricingSetID }) // save the setting to the server
    }
  }

  return (
    <div className="flex items-center pl-9">
      <Form.InlineSelect
        isLoading={isLoading}
        data={pricingSets}
        setSelected={handlePricingSetSelect}
        selected={selectedPricingSet}
        label="Choose a set"
      />
    </div>
  )
}

export default PricingSetSelector
